import Accordion from 'react-bootstrap/Accordion';

function orientacionAccordion() {
  return (

    <Accordion className="m-5" defaultActiveKey={[' ']} alwaysOpen>
      <Accordion.Item eventKey="0">
        <Accordion.Header>  Objetivos del Ciclo Básico</Accordion.Header>
        <Accordion.Body style={{ fontSize: '0.85rem' }}>
          <p>•	Promover la formación académica de los estudiantes en diversas disciplinas. </p>
          <p>•	Favorecer la comprensión y el análisis de los modos en que las tecnologías de información y comunicación
            generan nuevas maneras de sociabilidad, participación y de subjetivación, particularmente
            en lo referido a las modificaciones en las percepciones de espacio y tiempo.  </p>
          <p>•	Promover la construcción de estrategias para el ejercicio de las relaciones interpersonales.  </p>
          <p>•	Propiciar instancias de realización de actividades solidarias, que permitan construir actitudes de empatía y
            lazos de convivencia con la comunidad.  </p>
          <p>•	Favorecer la construcción de estrategias para el ejercicio de la ciudadanía.  </p>


        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="1">
        <Accordion.Header>Objetivos del Ciclo Orientado en Ciencias Sociales y Humanidades</Accordion.Header>
        <Accordion.Body style={{ fontSize: '0.85rem' }}>
          <p> •	Promover la ampliación y profundización de la información y teorías del pensamiento humanístico y social que aportan a la complejización de la comprensión y reflexión sobre las diferentes dimensiones de la vida social en situaciones problemáticas del pasado y del presente.</p>
          <p> •	Fortalecer la producción en diferentes formatos y registros, explicaciones e interpretaciones de acontecimientos y procesos sociales, ambientales, territoriales y culturales, desde una perspectiva multidimensional y multicausal.</p>
          <p> •	Promover el análisis crítico de las diversas fuentes con las que se construye el conocimiento social y humanístico y las diferentes teorías e interpretaciones sobre acontecimientos, procesos y fenómenos de la vida social.</p>
          <p> •	Desarrollar el análisis crítico de los discursos de los medios de comunicación y elaborar producciones culturales acerca de los temas y problemas relevantes de la vida social, en distintos contextos y escalas de análisis.</p>
          <p> •	Favorecer la comprensión y el análisis de los modos en que las tecnologías de información y comunicación generan nuevas maneras de sociabilidad, participación y de subjetivación, particularmente en lo referido a las modificaciones en las percepciones de espacio y tiempo.</p>
          <p> •	Promover la comprensión de las identidades individuales y colectivas como resultados de procesos de construcción social y cultural y reconocer la diversidad cultural, étnica, lingüística, religiosa, de género, en diferentes escalas espaciales y temporales.</p>
          <p> •	Propiciar instancias de realización de actividades solidarias, que permitan construir actitudes de empatía y lazos de convivencia con la comunidad.</p>
          <p> •	Promover la construcción de estrategias para el ejercicio de la ciudadanía.</p>
        </Accordion.Body>

      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header>Objetivos del Ciclo Orientado en Lenguas</Accordion.Header>
        <Accordion.Body style={{ fontSize: '0.85rem' }}>

          <p> 	Fortalecer la enseñanza de la comprensión, producción e interacción oral, la lectura y la escritura. </p>
          <p>  •	Facilitar las condiciones para el aprendizaje de la lengua extranjera y su uso en contextos situacionales a través de la resolución de tareas comunicativas. </p>
          <p> •	Ofrecer una amplia gama de géneros discursivos, dando relevancia particular a la literatura en tanto género de circulación social, producción artística, representación de idiosincrasias y acervo ideológico propio de las lenguas y culturas. </p>
          <p>•	Promover la reflexión acerca del uso del español, la lengua de escolarización, a partir de las prácticas de la oralidad, la lectura y la escritura. </p>
          <p>•	Integrar los recursos tecnológicos a disposición de los estudiantes para favorecer el aprendizaje de lenguas extranjeras. </p>
          <p>•	Promover el acercamiento y la valorización de otras lenguas y culturas para contribuir a la formación ciudadana. </p>
          <p>•	Fortalecer actitudes vinculadas con las relaciones interpersonales, la confianza en las propias posibilidades, la relación con el conocimiento y el respeto por lo diferente. </p>
          <p>•	Propiciar instancias de realización de actividades solidarias, que permitan construir actitudes de empatía y lazos de convivencia con la comunidad. </p>
          <p>•	Promover la construcción de estrategias para el ejercicio de la ciudadanía.  </p>

        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="3">
        <Accordion.Header> Período de inicio</Accordion.Header>
        <Accordion.Body style={{ fontSize: '0.85rem' }}>

          <p> Cada año, el ciclo lectivo inicia de acuerdo con lo estipulado por Calendario académico del Ministerio de Educación de la Provincia de La Pampa. En el caso de 1° año comienzan con antelación al resto de los cursos, con el propósito de promover actividades de ambientación al nivel y diagnóstico. Por su parte, los cursos comprendidos entre 2° y 6° año, dan inicio posteriormente y en las primeras jornadas se realizan actividades de revisión de saberes y diagnósticas.
            Idiomas: Inglés, Francés y Portugués
            Desde su Fundación, el Colegio Santo Tomás promueve la formación en la lengua extranjera Inglés. Además, en la Orientación Lenguas, contamos con horas cátedra de Lengua Francesa y Portuguesa, así como también, de Estudios Interculturales en Inglés y en Portugués.
          </p>

        </Accordion.Body>
      </Accordion.Item>


      <Accordion.Item eventKey="4">
        <Accordion.Header>Formación Religiosa Católica</Accordion.Header>
        <Accordion.Body style={{ fontSize: '0.85rem' }}>
          <p> Por definición institucional, desde su Fundación se optó por la Formación católica.De esta manera, se dicta el espacio de Formación Religiosa Católica, en los tres años del Ciclo Básico y Teología, en el Ciclo Orientado.Al finalizar la trayectoria por el Ciclo Básico, se ofrece la posibilidad de recibir el Sacramento de la “Confirmación”, de forma optativa.
          </p>

        </Accordion.Body>
      </Accordion.Item>


      <Accordion.Item eventKey="5">
        <Accordion.Header>
          Música y Arte
        </Accordion.Header>
        <Accordion.Body style={{ fontSize: '0.85rem' }}>

          <p>Para promover la educación artística los estudiantes transitan la formación en Artes visuales y en Música.La enseñanza de Música está centrada en el Ciclo Básico y la de Artes visuales, de 1° a 4° año.Al finalizar la trayectoria por la educación artística los estudiantes, junto a los docentes, realizan la “Fiesta de las Artes”, en la que exponen sus producciones artísticas en relación con una temática.
          </p>

        </Accordion.Body>
      </Accordion.Item>


      <Accordion.Item eventKey="7">
        <Accordion.Header>
          Participación estudiantil: Consejo de Aula y Consejo escolar de convivencia
        </Accordion.Header>

        <Accordion.Body style={{ fontSize: '0.85rem' }}>

          <p>En la Institución contamos con dos órganos de participación: el Consejo de aula y el Consejo escolar de convivencia.El primero constituye un espacio privilegiado para que los estudiantes puedan desarrollar mecanismos participativos y compositivos(diálogo positivo, círculos proactivos, mediación, entre otros) como herramienta favorable para la resolución de conflictos.Está integrado por: estudiantes del grupo clase, delegadas o delegados estudiantes de cada curso y docentes.
          </p>

        </Accordion.Body>
      </Accordion.Item>
    </Accordion>

  );
}
export default orientacionAccordion;



